export default __webpack_public_path__ + "static/media/partners-logo-hanyang-w@2x.4f309574.webp";